module.exports = __webpack_public_path__ + "static/media/mk.4cba3707.svg";